import { Button, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import {
  callAPI,
  customValidation,
  IRoleMain,
  IsSmallScreen,
  MasterPages,
  Method,
  validations,
} from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSRadioField from "../../Components/Radio/WSRadio";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import WSPhone from "../../Components/Phone/WSPhone";

interface FirmProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  departmentId?: string;
  setValue: any;
}
const Firm: React.FC<FirmProps> = ({
  control,
  errors,
  register,
  id,
  reset,
  departmentId,
  setValue,
}) => {
  const isMobile = IsSmallScreen();
  useEffect(
    () => () => {
      reset();
    },
    [id, reset]
  );

  const [showDetails, setShowDetails] = useState(false);

  return (
    <>
      <Grid
        style={{
          paddingLeft: 5,
          paddingRight: 20,
          position: "relative",
          margin: 0,
          marginTop: "3rem",
        }}
        container
        spacing={2}
      >
        <Grid item xs={12}>
          <WSImageUpload
            control={control}
            id="addLogo"
            name="addLogo"
            label=""
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"Business Name"}
            {...register("businessName")}
            id="businessName"
            name="businessName"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            label={"GSTIN"}
            {...register("gstin")}
            id="gstin"
            name="gstin"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSPhone
            label={"Phone Number"}
            id={"phoneNumber"}
            name={"phoneNumber"}
            control={control}
            rules={{ required: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            className="form-control"
            id="email"
            type={TextType.Text}
            rules={customValidation(false, validations.email)}
            {...register("email")}
            label="Email Id"
            control={control}
          />
        </Grid>
        {/* Toggle Button */}
      <Grid item xs={12}>
        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            fontWeight: 600,
          }}
          onClick={() => setShowDetails((prev) => !prev)}
        >
          {showDetails ? "Business Details" : "More Information"}
        </Typography>
      </Grid>

      {/* Conditionally Render Details */}
      {showDetails && (
        <>
          <Grid item xs={12} sm={6}>
            <WSTextAreaField
              label={"Business Address"}
              id={"businessAddress"}
              name={"businessAddress"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSTextAreaField
              label={"Business Description"}
              id={"businessDescription"}
              name={"businessDescription"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSSelectField
              rules={{ required: true }}
              control={control}
              id="businessType"
              {...register("businessType")}
              name="businessType"
              label="Business Type"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSTextField
              label={"Business Category"}
              {...register("businessCategory")}
              id="businessCategory"
              name="businessCategory"
              control={control}
              rules={{ required: false }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSTextField
              label={"Pincode"}
              {...register("pincode")}
              id="pincode"
              name="pincode"
              control={control}
              rules={{ required: false }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <WSSelectField
              rules={{ required: true }}
              control={control}
              id="state"
              {...register("state")}
              name="state"
              label="State"
            />
          </Grid>
          </>
      )}
       
      </Grid>
    </>
  );
};
export default Firm;
